/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import DesktopCardInfo from '../DesktopCardInfo';
import { isEmpty } from '../../../utils/object';
import getSiteConfig from '../../../utils/getSiteConfig';

class DesktopInfos extends React.Component {
    canModifyOrderInfoCard = (className = '') => {
        const title = (
            <>
                Orders That <span className="bold">Can</span> Be Modified
            </>
        );
        const body = (
            <>
                <ul className="no-margin">
                    <li>
                        To edit a section, click the <b>MODIFY</b> button.
                    </li>
                    <li>
                        Each order can be modified once. Edit all sections
                        before clicking <b>SUBMIT</b>.
                    </li>
                    <li>You&apos;ll receive an email confirming your changes.</li>
                </ul>
                <div className="padding-10">Payment details cannot be edited online.</div>
            </>
        );
        return <DesktopCardInfo cartStyle="margin-right-10" className={className} title={title} body={body} />;
    };

    cannotModifyOrderInfoCard = (className = '') => {
        const siteConfig = getSiteConfig();
        const phoneNumber = siteConfig.phoneNumber || '';
        const phoneNumberShort = siteConfig.phoneNumberShort || '';
        const orderServiceEmail = siteConfig['order-service-email'] || '';
        const title = (
            <>
                Orders That <span className="bold">Cannot</span> Be Modified
            </>
        );
        const body = (
            <div className="no-margin-top padding-10">
                <div>
                    <span className="error-color bold">
                        “This Order May No Longer Be Modified”
                    </span>{' '}
                    means that your order has been processed and is ready to be
                    shipped, in-transit, or out for delivery.
                </div>
                <div className="margin-top">
                    For further assistance,{' '}
                    {orderServiceEmail ? (
                        <a
                            className="link"
                            href={`mailto:${orderServiceEmail}`}
                        >
                            email us
                        </a>
                    ) : (
                        'email us'
                    )}{' '}
                    or call{' '}
                    <a
                        className="link whitespace-nowrap"
                        href={`tel:+${phoneNumberShort}`}
                    >
                        {phoneNumber}
                    </a>
                    <br />
                </div>
            </div>
        );
        return <DesktopCardInfo cartStyle="margin-left-10" className={className} title={title} body={body} />;
    };

    render() {
        const { featureFlags } = this.props;
        const ENABLE_MMO =            !isEmpty(featureFlags)
            && featureFlags['is-account-mmo-enabled'] === true;
        const instructionClassName = !ENABLE_MMO ? 'display-none' : '';
        return (
            <>
                <Grid container>
                    <Grid className="margin-bottom" item xs={6}>
                        {this.canModifyOrderInfoCard(instructionClassName)}
                    </Grid>
                    <Grid className="margin-bottom" item xs={6}>
                        {this.cannotModifyOrderInfoCard(instructionClassName)}
                    </Grid>
                </Grid>
            </>
        );
    }
}

DesktopInfos.defaultProps = {
    featureFlags: {},
};

DesktopInfos.propTypes = {
    featureFlags: PropTypes.object,
};

export default DesktopInfos;
